import * as physicalListActions from './PhysicalList/actions';
import * as createEditPhysicalActions from './CreateEditPhysical/actions';

export const actions = {
  ...physicalListActions,
  ...createEditPhysicalActions,
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/state/actions.js